import { AnyAction } from 'redux';
import { reducerWrapper } from '../../support/utils';
import { FETCH_LINKS_BY_QUERY } from '../../actions/LinkManager/FetchLinksByQueryActions';
import { LinkByQueryReducerType } from './Types/LinkByQueryReducerType';

const INIT_STATE: LinkByQueryReducerType = {
  loading: true,
  loadingStatus: 0,
  error: null,
  links: [],
  total: 0,
  analyticTotal: 0,
};

const Handler = (state: LinkByQueryReducerType, action: AnyAction) => {
  switch (action.type) {
    case FETCH_LINKS_BY_QUERY.response:
      return {
        ...state,
        loading: false,
        links: action.data?.data?.links || [],
        total: action.data?.data?.total | 0,
      };
    default:
      return state;
  }
};

const TypelessHandler = (state: any, action: any) => {
  return Handler(state, action);
};

const LinkByQueryReducer = reducerWrapper(INIT_STATE, TypelessHandler, {
  request: [FETCH_LINKS_BY_QUERY],
  error: [FETCH_LINKS_BY_QUERY],
});

export default LinkByQueryReducer;
